/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState, useEffect } from 'react';
import axios from 'axios';
import classes from './expertDashboard.module.css';
import Skeleton from '../../components/skeleton/skeleton';
import { FiDollarSign, FiUsers, FiTrendingUp, FiUserPlus, FiInbox } from 'react-icons/fi';
import { format } from 'date-fns';

const url = process.env.REACT_APP_BACKEND_URL;

export default function ExpertDashboard() {
    const [summary, setSummary] = useState(null);
    const [payouts, setPayouts] = useState([]);
    const [pagination, setPagination] = useState({ page: 1, pages: 1, total: 0 });
    const [isSummaryLoading, setIsSummaryLoading] = useState(true);
    const [isPayoutsLoading, setIsPayoutsLoading] = useState(true);

    const fetchSummary = async () => {
        const config = {
            headers: {
                authorization: `Bearer ${localStorage.getItem('tok')}`
            }
        };

        setIsSummaryLoading(true);
        try {
            const response = await axios.get(`${url}/payment/expert-summary`, config);
            setSummary(response.data);
        } catch (error) {
            console.error('Error fetching expert summary:', error);
        } finally {
            setIsSummaryLoading(false);
        }
    };

    const fetchPayouts = async (p = 1) => {
        const config = {
            headers: {
                authorization: `Bearer ${localStorage.getItem('tok')}`
            }
        };

        setIsPayoutsLoading(true);
        try {
            const response = await axios.get(`${url}/payment/payouts?page=${p}`, config);
            setPayouts(response.data.payouts);
            setPagination(response.data.pagination);
        } catch (error) {
            console.error('Error fetching expert payouts:', error);
        } finally {
            setIsPayoutsLoading(false);
        }
    };

    useEffect(() => {
        fetchSummary();
        fetchPayouts();
    }, []);

    const formatCurrency = (amount) => {
        return `₦${Number(amount || 0).toLocaleString()}`;
    };

    const getStatusClass = (status) => {
        switch (status?.toLowerCase()) {
            case 'paid':
                return classes.statusPaid;
            case 'pending':
                return classes.statusPending;
            case 'failed':
                return classes.statusFailed;
            default:
                return classes.statusPending;
        }
    };

    const stats = [

        {
            label: 'Overall Earned From Best Codes',
            value: formatCurrency(summary?.amountMade),
            icon: <FiTrendingUp className={classes.statIcon} />,
        },
        {
            label: 'Total Money Paid To Expert',
            value: formatCurrency(summary?.totalSettlement),
            icon: <FiDollarSign className={classes.statIcon} />,
        },
        {
            label: 'How Many Referrals Used Your Code',
            value: summary?.totalReferrals || 0,
            icon: <FiUsers className={classes.statIcon} />,
        },
        {
            label: 'How Many Times Referrals Subscribed',
            value: summary?.referralsThatPaid || 0,
            icon: <FiUserPlus className={classes.statIcon} />,
        },

    ];

    if (isSummaryLoading && isPayoutsLoading) {
        return (
            <div className={classes.container}>
                <div className={classes.welcomeSection}>
                    <h1 className={classes.welcomeTitle}>Expert Dashboard</h1>
                    <p className={classes.welcomeSubtitle}>Loading your stats...</p>
                </div>
                <div className={classes.skeletonGrid}>
                    {[...Array(5)].map((_, i) => (
                        <div key={i} className={classes.skeletonCard}>
                            <Skeleton width={'100%'} height={'100%'} />
                        </div>
                    ))}
                </div>
                <div className={classes.skeletonTable}>
                    <Skeleton width={'100%'} height={'100%'} />
                </div>
            </div>
        );
    }

    return (
        <div className={classes.container}>
            {/* <div className={classes.welcomeSection}>
                <h1 className={classes.welcomeTitle}>
                    Welcome back, {user?.first_name} 👋
                </h1>
                <p className={classes.welcomeSubtitle}>
                    Here's an overview of your expert earnings and referrals.
                </p>
            </div> */}

            {/* Stat Cards */}
            <div className={`${classes.statCard} ${classes.referrals}`}>
                <div className={classes.statIconContainer}>
                    <FiDollarSign className={classes.statIcon} />
                </div>
                <p className={classes.statLabel}>Amount Accumulated After Last Payout</p>
                <p className={classes.statValue}>{summary?.totalAvailable}</p>
            </div>

            <div className={classes.statsGrid}>
                {stats.map((stat, index) => (
                    <div key={index} className={`${classes.statCard} ${stat.colorClass}`}>
                        <div className={classes.statIconContainer}>
                            {stat.icon}
                        </div>
                        <p className={classes.statLabel}>{stat.label}</p>
                        <p className={classes.statValue}>{stat.value}</p>
                    </div>
                ))}
            </div>

            {/* Payout History Table */}
            <div className={classes.historySection}>
                <div className={classes.historyHeader}>
                    <h2 className={classes.historyTitle}>Payout History</h2>
                    <span className={classes.historyCount}>{pagination.total} record{pagination.total !== 1 ? 's' : ''}</span>
                </div>

                {payouts.length > 0 ? (
                    <>
                        <table className={classes.table}>
                            <thead>
                                <tr>
                                    <th>Date</th>
                                    <th>Amount</th>
                                    <th>Status</th>
                                </tr>
                            </thead>
                            <tbody>
                                {payouts.map((entry, index) => (
                                    <tr key={index}>
                                        <td>{entry.createdAt ? format(new Date(entry.createdAt), 'MMM dd, yyyy') : '—'}</td>
                                        <td>{formatCurrency(entry.amount)}</td>
                                        <td>
                                            <span className={`${classes.statusBadge} ${getStatusClass(entry.status)}`}>
                                                {entry.status || 'paid'}
                                            </span>
                                        </td>
                                    </tr>
                                ))}
                            </tbody>
                        </table>
                        {pagination.pages > 1 && (
                            <div className={classes.pagination}>
                                <button
                                    onClick={() => fetchPayouts(pagination.page - 1)}
                                    disabled={pagination.page === 1 || isPayoutsLoading}
                                >
                                    Previous
                                </button>
                                <span>Page {pagination.page} of {pagination.pages}</span>
                                <button
                                    onClick={() => fetchPayouts(pagination.page + 1)}
                                    disabled={pagination.page === pagination.pages || isPayoutsLoading}
                                >
                                    Next
                                </button>
                            </div>
                        )}
                    </>
                ) : (
                    <div className={classes.emptyState}>
                        <FiInbox className={classes.emptyIcon} />
                        <p>No payout history yet. Start referring to earn!</p>
                    </div>
                )}
            </div>
        </div>
    );
}
